export const login =  ({user, pass}) => {
  let formData = new FormData;

  formData.append('usr', user);
  formData.append('pw', pass);

  return fetch('/api/pub/login.php', {
    method: 'POST',
    body: formData
  });
};

export const logout =  ({isAdmin = false}) => {
  let endPoint = `/api/${isAdmin ? 'admin' : 'mem'}/logout.php`

  localStorage.removeItem('user');
  return fetch(endPoint, {method: 'POST'});
};

export const getUser = () => {
  return fetch('/api/mem/getUser.php');
}

export const getAdminPicks =  ({service}) => {
  return fetch(`/api/admin/getPicks.php?service=${service}&_cb=${new Date().getTime()}`);
}

export const updateAdminPick =  ({id, service, edits}) => {
  return fetch('/api/admin/updatePick.php', {
    method: 'POST',
    body: JSON.stringify({id, service, edits})
  });
}

export const removeManualPick = ({id, service}) => {
  return fetch('/api/admin/removePick.php', {
    method: 'POST',
    body: JSON.stringify({id, service})
  });
}

export const getServices =  (service) => {
  let reqData = {
    service,
    _cb: new Date().getTime()
  };
  let qString = Object
    .keys(reqData)
    .filter(qKey => reqData[qKey])
    .map(qKey => `${qKey}=${reqData[qKey]}`)
    .join('&');

  return fetch(
    `/api/admin/getServices.php?${qString}`
  );
}

export const updateService =  ({id, edits}) => {
  return fetch('/api/admin/updateService.php', {
    method: 'POST',
    body: JSON.stringify({
      id,
      edits
    })
  });
}

export const removeService = ({id}) => {
  return fetch('/api/admin/removeService.php', {
    method: 'POST',
    body: JSON.stringify({id})
  })
}

export const getUserPicks = () => {
  return fetch(`/api/mem/getPicks.php?_cb=${new Date().getTime()}`);
}

export const updateProfile = ({edits}) => {
  let formData = new FormData();

  for (let field in edits) {
    formData.append(field, edits[field]);
  }

  return fetch('/api/mem/updateProfile.php', {
    method: 'POST',
    body: formData
  });
}

export const createProfile = (user) => {

  return fetch('/api/pub/createProfile.php', {
    method: 'POST',
    body: JSON.stringify(user)
  });
}

export const getPending = (service) => fetch(`/api/pub/getPending.php?service=${service}&_cb=${new Date().getTime()}`);

export const getBoard = () => fetch(`/api/pub/getBoard.php?_cb=${new Date().getTime()}`);

export const sendPicksAlert = (services) => {
  return fetch('/api/admin/sendPicksPostedNotification.php', {
    method: 'POST',
    body: JSON.stringify(services)
  });
}

export const sendResetPasswordEmail = (emailOrUser) => {
  return fetch('/api/pub/forgotPW.php', {
    method: 'POST',
    body: JSON.stringify({user: emailOrUser})
  })
}

export const updateForgottenPassword = ({pass, passConfirm, code}) => {
  return fetch('/api/pub/updateForgottenPassword.php', {
    method: 'POST',
    body: JSON.stringify({pass, passConfirm, code})
  })
}

export const getModules = () => fetch('/api/mem/getModules.php');

export const getUpSell = ({flowId}) => fetch(`/api/pub/cbfid.php?id=${flowId}&_cb=${new Date().getTime()}`);
